import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { UploadDownloadService } from '../file-upload/upload-download.service';
import { HttpEventType } from '@angular/common/http';
import { ProgressStatus, ProgressStatusEnum } from '../../../models/progress-status.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-upload',
  templateUrl: 'upload.component.html',
  styleUrls: ['./upload.component.scss'],
})

export class UploadComponent {
  @Input() public disabled: boolean;
  @Output() public uploadStatus: EventEmitter<ProgressStatus>;
  @ViewChild('inputFile') inputFile: ElementRef;
  @Output() public showUploadState: any;

  constructor(private service: UploadDownloadService,private sanitizer: DomSanitizer) {
    this.uploadStatus = new EventEmitter<ProgressStatus>();
  }

  public upload(event, action) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.service.setPath(this.sanitizer.bypassSecurityTrustUrl(file));
      this.uploadStatus.emit( {status: ProgressStatusEnum.START});
      this.service.uploadFile(file, action).subscribe(
        data => {
          if (data) {
            switch (data.type) {
              case HttpEventType.UploadProgress:
                this.uploadStatus.emit( {status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total) * 100)});
                break;
              case HttpEventType.Response:
                this.inputFile.nativeElement.value = '';
                this.uploadStatus.emit( {status: ProgressStatusEnum.COMPLETE});
                this.showUploadState = "حجم فایل آپلود شده بیشتر از حد مجاز است!";
                break;
            }
          }
        },
        error => {
          this.inputFile.nativeElement.value = '';
          this.uploadStatus.emit( {status: ProgressStatusEnum.ERROR});
        }
      );
    }
  }
}
